module.exports = __webpack_public_path__ + "img/act_pro_img8s_03.9b62dc55.png";